module.exports = __webpack_public_path__ + "static/logo-mi-retrato-ed7aa67229d8d257d1ed257eb5f85077.png";